import { render, staticRenderFns } from "./radar-chart.vue?vue&type=template&id=9ec4f170"
import script from "./radar-chart.vue?vue&type=script&lang=js"
export * from "./radar-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports